'use client';

import { useAppContext } from '@/context/app';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function Template({ children }) {
  const [
    ,
    {
      actions: { setActiveColumn },
    },
  ] = useAppContext();
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === '/' || pathname === '/attire' || pathname === '/cart') {
      return;
    }

    setActiveColumn('home');
  }, [setActiveColumn, pathname]);

  return children;
}
